LS.getAmountToScroll = function(naturalWidth, availableWidth, gutter){
  var amountToScroll = naturalWidth - availableWidth;
  if( $(window).outerWidth() < LS.tabletBreakpoint ){
    // account for the extra gutter on the first item
    amountToScroll = amountToScroll + gutter;
  }
  return amountToScroll;
}
LS.getPressHandleAmountToScroll = function($row, $handle){
  return $row.closest('.pr-slider').find('.press-row-bar').outerWidth() - $handle.outerWidth();
};
LS.pressRowInit = function(firstInit){
  if( !$('.pr-slider').length || $(window).width() > 768 ){
    $('.press-row-bar').remove();
    $('.pr-items-wrap').removeAttr('style');
    return;
  }

  // clear values
  $('.press-row-bar').remove();
  $('.pr-items-wrap').removeAttr('style');

  $('.pr-items').each(function(){
    var $this = $(this);
    var $items = $this.find('.item');
    var hiddenItems = $this.find('.hidden'); // .find().not() breaks things
    var $sampleItem = $items.first();
    var gutter = Number($sampleItem.css('padding-right').replace('px',''));
    var itemWidth = $sampleItem.outerWidth();
    // first item has an extra left gutter on mobile, so remove that value for an accurate size for all items
    if( $(window).outerWidth() < LS.tabletBreakpoint ){
      itemWidth = itemWidth - gutter;
    }
    // figure out how wide this row would be
    var naturalWidth = itemWidth * ($items.length - hiddenItems.length); 
    // remove one gutter value on tablet and up due to last child having it's padding removed
    if( $(window).outerWidth() >= LS.tabletBreakpoint ){
      naturalWidth = naturalWidth - gutter;
    }
    // visible area of the row
    var availableWidth = $this.outerWidth();
    // do we need to scroll?
    if( naturalWidth > availableWidth ){ 
      $this.data('natural-width', naturalWidth);
      $this.data('available-width', availableWidth);
      $this.data('gutter', gutter);
      // add our scrollbar
      $('<div class="press-row-bar"><div class="handle" style="width: ' + availableWidth/naturalWidth*100 + '%"></div></div>').insertAfter($this.closest('.pr-items-wrap'));
      // how many pixels are we hanging off the side
      var amountToScroll = LS.getAmountToScroll(naturalWidth, availableWidth, gutter);
      // how far does the handle need to move
      var $handle = $this.closest('.pr-slider').find('.handle');
      var handleAmountToScroll = LS.getPressHandleAmountToScroll($this, $handle);
      $this.on('scroll', function(){
        // dragging + auto-moving the bar conflicts
        if( $('body').hasClass('dragging') ) return;
        // of the distance we need to scroll, how far have we gone?
        var percentScrolled = $this.scrollLeft()/amountToScroll;
        // apply this progress how far the handle should move
        var translateAmt = percentScrolled * handleAmountToScroll;
        $handle.css({
          'left' : translateAmt,
          // transform performs better, but left get used by draggable
          // 'transform': 'translate3d(' + translateAmt + 'px, 0, 0)'
        });
      });
      // set the cropping window's height to hide iOS scrollbar
      // 2021-03: seems this is no longer necessary for iOS. 
      // $this.imagesLoaded( function() {
      //   $this.closest('.pr-items-wrap').height($this.outerHeight() - $this.css('padding-bottom').replace('px',''));
      // });
    }

    // set up row heading text
    if( firstInit ){
      // var $optionsEl = $(this).closest('.pr-slider').find('.configuration-options');
      // var options = [];
      // var materials = [];
      // var sizes = 1;
      // $items.each(function(){
      //   var materialName = $(this).find('.material').text();
      //   var variantCount = $(this).find('.product-link').data('variant-count');
      //   if($.inArray(materialName, materials) === -1){
      //     materials.push(materialName);
      //   }
      //   if( variantCount > sizes) {
      //     sizes = variantCount;
      //   }
      // });
      // if( materials.length > 1 ){
      //   options.push(materials.length + ' materials')
      // }
      // if( sizes > 1 ){
      //   options.push(sizes + ' sizes')
      // }
      // if( $items.length > 1 ){
      //   options.push($items.length + ' colors available');
      // }else{
      //   options.push('1 color available');
      // }
      // $optionsEl.html('<a href="' + $sampleItem.find('.product-link').attr('href') + '">' + options.join(' / ') + ' &gt;</a>');
    }
  });
};

LS.draggablePressScrollbar = function(){
  $('.press-row-bar .handle').each(function(){
    $(this).draggable({
      axis: 'x',
      containment: 'parent',
      drag: function( event, ui ) {
        $('body').addClass('dragging');
        let $handle = $(event.target);
        let $productRow = $handle.closest('.pr-slider').find('.pr-items-wrap .pr-items');
        var handleAmountToScroll = LS.getPressHandleAmountToScroll($productRow, $handle);
        var percentScrolled = ui.position.left/handleAmountToScroll;
        var amountToScroll = LS.getAmountToScroll($productRow.data('natural-width'), $productRow.data('available-width'), $productRow.data('gutter'));
        $productRow.scrollLeft(amountToScroll * percentScrolled);
        $handle.addClass('dragging');
      },
      stop: function( event, ui ) {
        $(event.target).removeClass('dragging');
        $('body').removeClass('dragging');
      }
    });
  });
}

$(document).ready(function(){

	LS.pressRowInit(true);
	$(window).resize(function(){
		LS.pressRowInit(false); 
		LS.draggablePressScrollbar();
	});

	$('.press-row-bar .handle').each(function(){
		$(this).draggable({
			axis: 'x',
			containment: 'parent',
			drag: function( event, ui ) {
				$('body').addClass('dragging');
				let $handle = $(event.target);
				let $productRow = $handle.closest('.pr-slider').find('.pr-items-wrap .pr-items');
				var handleAmountToScroll = LS.getPressHandleAmountToScroll($productRow, $handle);
				var percentScrolled = ui.position.left/handleAmountToScroll;
				var amountToScroll = LS.getAmountToScroll($productRow.data('natural-width'), $productRow.data('available-width'), $productRow.data('gutter'));
				$productRow.scrollLeft(amountToScroll * percentScrolled);
				$handle.addClass('dragging');
			},
			stop: function( event, ui ) {
				$(event.target).removeClass('dragging');
				$('body').removeClass('dragging');
			}
		});
	});
});